<template>
  <div class="avatar-container">
    <div class="avatar-details" id="details" ref="details">
        <div class="detail">
            <span class="value-title">Idade</span>
            <span class="value">{{user.age}}</span>
        </div>
        <div class="detail">
            <span class="value-title">Sexo biológico</span>
            <span class="value">{{user.gender}}</span>
        </div>
        <div class="detail">
            <span class="value-title">Pressão (sistólica)</span>
            <span class="value">{{user.pressure_high}} </span>
        </div>
        <div class="detail">
            <span class="value-title">Pressão (diastólica)</span>
            <span class="value">{{user.pressure_low}}</span>
        </div>
        <div class="detail">
            <span class="value-title">Circunferência abdominal</span>
            <span class="value">{{user.circunference}}</span>
        </div>
    </div>
    <div class="avatar-box">
      <img class="avatar" src="@/assets/images/risks/avatar_riscos.png" />
      <div v-if="showHead" class="avatar-area cabeca" @click.prevent="$emit('changeRisk', 1)">
        <font-awesome-icon class='btn-svg' :icon="['fa', 'plus-circle']"/>
      </div>
      <div v-if="showTorso" class="avatar-area peito" @click.prevent="$emit('changeRisk', 2)">
        <font-awesome-icon class='btn-svg' :icon="['fa', 'plus-circle']"/>
      </div>
      <div v-if="showAbdomen" class="avatar-area abdomen" @click.prevent="$emit('changeRisk', 3)">
        <font-awesome-icon class='btn-svg' :icon="['fa', 'plus-circle']"/>
      </div>
      <div v-if="showPelvis" class="avatar-area pelvis" @click.prevent="$emit('changeRisk', 4)">
        <font-awesome-icon class='btn-svg' :icon="['fa', 'plus-circle']"/>
      </div>
      <div v-if="showLeg" class="avatar-area perna" @click.prevent="$emit('changeRisk', 5)">
        <font-awesome-icon class='btn-svg' :icon="['fa', 'plus-circle']"/>
      </div>
      <div v-if="showOut" class="avatar-area fora" @click.prevent="$emit('changeRisk', 6)">
        <font-awesome-icon class='btn-svg' :icon="['fa', 'plus-circle']"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "risk-avatar",
  components: { },
  props: {
    kitTypeId: Number,
    currentRisk: Number,
    customer: Object,
    answers: Array,
    showHead: Boolean,
    showTorso: Boolean,
    showAbdomen: Boolean,
    showPelvis: Boolean,
    showLeg: Boolean,
    showOut: Boolean,
  },
  data() {
    return {
      kitType: null,
      user: {
        age: null,
        pressure_high: null,
        pressure_low: null,
        circunference: null,
        gender: null,
      },
    }
  },
  watch: {
    currentRisk(newRisk, oldRisk) {
        // let details = this.$refs.details
        // if(newRisk != 0 && oldRisk == 0) { details.classList.remove("open"); details.classList.add("closee"); }
        // if(newRisk == 0 && oldRisk != 0) { details.classList.remove("closee"); details.classList.add("open"); }
      }
  },
  methods: {
    loadUser() {
        this.user.age = this.customer.age;
        this.user.pressure_high = this.answerSearch("Sistólica (alta):");
        this.user.pressure_low = this.answerSearch("Diastólica (baixa):");
        this.user.circunference = this.answerSearch("Circunferência abdominal (centímetros)");
        this.user.gender = this.customer.gender == 'M' ? 'Masculino' : 'Feminino';
    },
    answerSearch(field, multiple = false, answers = []) {
      let ans = null;
      if (multiple) {
          if (answers.length > 0) {
              ans = this.answers.filter(a => {
                  return a.field.title == field && answers.includes(a.option.value);
              }).map(a => {
                  return a.option.value;
              });
              return ans.join(', ');
          } else {
              ans = this.answers.filter(a => {
                  return a.field.title == field;
              }).map(a => {
                  return a.option.value;
              });
              return ans;
          }
      } else {
          this.answers.map(answer => {
              if (answer.field.title == field && !multiple)
                  ans = answer.response !== null ? answer.response : answer.option.label;
          });
      }
        return ans;
    },
  },
  mounted() {
    this.loadUser();
  }
}
</script>

<style>
    @import "./risk-avatar.scss";
    @import "./responsive.css";
</style>


// WEBPACK FOOTER //
// src/components/RiskAvatar/RiskAvatar.vue